<p-dialog
  *ngIf="displayIntervalDialog"
  header="Intervall angeben"
  [(visible)]="displayIntervalDialog"
  [modal]="true"
  (onHide)="onHide()"
  [style]="{ width: '400px' }"
  appendTo="body"
>
  <jml-lib-interval-control [interval]="interval" (formState)="handleFormState($event)"></jml-lib-interval-control>
  <button
    pButton
    label="Speichern"
    class="mt-3"
    [disabled]="!isFormValid"
    [id]="fieldName + '§' + rowData['id']"
    (click)="onSave()"
  ></button>
</p-dialog>

<div class="cell-view">
  <div class="inner-view">
    <span *ngIf="rowData[fieldName]">
      {{ originalContent ? originalContent['repr'] : rowData[fieldName]?.repr }}
    </span>
  </div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="IntervalCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="IntervalCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>
